import { Chip, Grid } from '@mui/material';
import React from 'react';

const FeatureFlagBadge = ({ title, activeSetting }) => {
    return (
        <Grid
            gap='.15em'
            alignItems='center'
            wrap='nowrap'
            className='feature-flag'
            justifyContent='space-between'
            container
            key={`flag-${title}`}
        >
            <Grid item >
                {title}
            </Grid>
            <Grid item sx={{ flexBasis: '70px', textAlign: 'end' }}>
                <Chip
                    className='feature-flag-badge'
                    label={activeSetting ? 'Active' : 'Inactive'}
                    sx={(theme) => ({
                        background: activeSetting ? theme.palette.success.light : '#7c7c7c',
                    })}
                    size='small'
                />
            </Grid>
        </Grid>
    );
};

export default FeatureFlagBadge;